import React from "react";
import styled from "styled-components";

import {primaryTextColour, tableBorderColour, triggerColour} from "../../style/styleConsts";
import WhiteBox from "./WhiteBox";

const HoverTarget = styled(WhiteBox)`
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    border-radius: 4px;
    align-items: center;
    padding: 4px 8px;
    color: ${primaryTextColour};
    border-bottom: 1px solid ${tableBorderColour};
    border-radius: 0;
    
    :hover {
        background-color: ${triggerColour};
        color: white;
        border-color: transparent;
        border-radius: 3px;
    }
`;

export default HoverTarget;